<template>
  <v-btn
    :type="type"
    :color="color"
    :disabled="disabled"
    @click="handleClick"
    class="loading-btn"
  >
    <template v-if="disabled">
      <ClipLoader size="20px" color="white" class="loading-spinner" />
      <span> Loading...</span>
    </template>
    <span v-else><slot>Create account</slot></span>
  </v-btn>
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

export default {
  components: {
    ClipLoader
  },
  props: {
    color: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'secondary'].includes(value)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'button'
    }
  },
  methods: {
    handleClick() {
      // Simulate an asynchronous operation (replace this with your actual logic)
      setTimeout(() => {
        this.$emit('click')
      }, 2000) // Simulating a 2-second delay
    }
  }
}
</script>

<style scoped>
.loading-spinner {
  padding-right: 10px;
}
</style>
